module.exports = __webpack_public_path__ + "media/images/slide-20-9bd027c31a0812f1f3845b2f482a7831.jpg";